<template>
  <v-app>
    <v-toolbar app height="75">
      <v-toolbar-title class="headline text-uppercase">
        <router-link :to="{name:'home'}" class="header-link">
          <v-layout>
            <v-flex>
              <v-img :src="logo2" width="300" />
            </v-flex>
          </v-layout>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="isAuthorized" >
        <v-chip @click="gotoProfile">
          <v-icon small>perm_identity</v-icon>
          {{identity.displayName}}
        </v-chip>
      </span>
      <v-tooltip bottom v-if="isAuthorized">
        <template v-slot:activator="args">
          <v-btn @click="doLogout" icon small v-on="args.on" :loading="isLoading">
            <v-icon>logout</v-icon>
          </v-btn>
        </template>
        <span>Logout from your account</span>
      </v-tooltip>
      <v-menu v-if="isAuthorized " v-model="ui.menu" :close-on-content-click="false" offset-x>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-tile v-if="isAdmin">
              <v-list-tile-action>
                <v-switch v-model="allowDelete"></v-switch>
              </v-list-tile-action>
              <v-list-tile-title>Allow Deletions</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="isAuthorized" :to="{name:'user-profile-update'}" @click="ui.menu=false">
              <v-list-tile-title>Change Password</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>

    <v-content>
      <router-view v-if="!isLoading" />
      <v-container v-if="isLoading">
        <v-layout>
          <v-flex>
            <v-card>
              <div class="text-xs-center pa-3">
                <v-progress-circular indeterminate color="green"></v-progress-circular>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer>
      <span v-if="ui.updating">
        <v-progress-circular indeterminate color="green"></v-progress-circular>downloading new update...
      </span>
      <div class="spacer"></div>
      <div>
        &copy; {{ new Date().getFullYear() }} {{meta.siteName}} | {{meta.version.major}}.{{meta.version.minor}}.{{meta.version.revision}}.{{meta.version.build}} | last updated
        <span :title="lastUpdatedDate">{{lastUpdated}}</span> &nbsp;
      </div>
    </v-footer>
    <v-snackbar v-model="ui.showAlert" color="success" :timeout="60000">
      <span>An update is available.</span>
      <v-btn dark flat @click="refresh">Refresh Now</v-btn>
    </v-snackbar>
    <v-snackbar v-model="ui.showSecureRedirect" color="error" :timeout="600000">
      <span>Redirecting to secure version...</span>
    </v-snackbar>

  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
var logo = require("./assets/Logo.png");
var logo2 = require("./assets/hockey-logo.png");

export default {
  name: "App",
  mounted: function () {
    var me = this;
    me.isLoading = true;
    if (
      window.location.protocol == "http:" &&
      this.meta.forceHttps &&
      window.location.hostname != "localhost"
    ) {
      me.ui.showSecureRedirect = true;
      setTimeout(function () {
        window.location.href = window.location.href.replace("http:", "https:");
      }, 1000);
      return;
    }
    console.log("request restore");
    me.tryRestoreIdentity()
      .catch(function (ex) {
        console.log("try restroe", ex);
        //me.$router.push({ name: "login" });
      })
      .finally(function () {
        me.isLoading = false;
      });

    document.addEventListener("update-available", function (evt) {
      console.log("event recived", evt);
      me.ui.updating = false;
      me.ui.showAlert = true;
      console.log("update-available handled", evt);
      me.newWorker = evt.detail.waiting;
    });
    document.addEventListener("update-found", function (evt) {
      console.log("event recived", evt);
      me.ui.updating = true;
    });

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", function () {
        if (me.refreshing) return;
        me.refreshing = true;
        window.location.reload();
      });
    }

    // if (window.BroadcastChannel) {
    //   var channel;
    //  this.channel=channel=new BroadcastChannel("update-notification");
    //   channel.onmessage=function(){
    //     me.ui.showAlert=true;
    //   };
    // }
  },
  computed: {
    ...mapState("config", ["identity", "meta", "options"]),
    isAuthorized: function () {
      return !!this.identity.token;
    },
    lastUpdated: function () {
      return moment(this.meta.version.date).fromNow();
    },
    lastUpdatedDate: function () {
      return moment(this.meta.version.date).format("MMM Do YYYY, hh:mm:ss a");
    },
    logo: function () {
      return logo;
    },
    logo2: function () {
      return logo2;
    },
    allowDelete: {
      get: function () {
        return this.options.showDeleteOption;
      },
      set: function (v) {
        this.toggleDelete(v);
      },
    },
    isAdmin: function () {
      return this.identity.type == "Administrator";
    },
  },
  data() {
    return {
      isLoading: true,
      ui: {
        updating: false,
        showAlert: false,
        showSecureRedirect: false,
        menu: false,
      },
    };
  },
  methods: {
    ...mapActions("config", ["tryRestoreIdentity", "logout"]),
    ...mapMutations("config", ["toggleDelete"]),
    doLogout: function () {
      var me = this;
      me.isLoading = true;
      me.logout()
        .then(function () {
          me.$cookies.remove("__auth");
        })
        .finally(function () {
          me.isLoading = false;
          me.$router.push({ name: "login" });
        });
    },
    refresh: function () {
      if(this.newWorker){
        this.newWorker.postMessage({type:"SKIP_WAITING"});
      }
    },
    gotoProfile:function(){
      this.$router.push({name:'user-profile-update'});
    }
  },
};
</script>
